export const actions = {
    HANDLE_MENU: 'HANDLE_MENU',
    HANDLE_MENU_DESKTOP: 'HANDLE_MENU_DESKTOP'
}